module.exports = __webpack_public_path__ + "static/media/error-red.e50b76fd.svg";